module.exports = __webpack_public_path__ + "img/page-not-found.b4369d5d.svg";